/** @module store/target_access_permissions */
import { formatTimestampToLocal } from '@/helpers/view_helpers'
import * as mutations from '@/store/modules/target_access_permissions/mutations'
import * as getters from '@/store/modules/target_access_permissions/getters'
import * as actions from '@/store/modules/target_access_permissions/actions'

export const TARGET_ACCESS_PERMISSIONS = {
  none: 0,
  read: 1,
  write: 2
}

export const DEFAULT_SENSOR_REGEXP = /((_meter_demand|_meter_supply|_power|_soc|_temperature|wallbox_state)\b)/g

const state = () => ({
  fullPermissionUserIds: [],
  restrictedPermissionUserIds: [],
  permissions: {}
})

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export class TargetAccessPermission {
  constructor({ id, permission, targetId, targetType, timeRanges, userId }) {
    for (const timerange of timeRanges) {
      if (!(timerange instanceof TimeRange)) throw new TypeError('incorrect TimeRanges given')
    }

    this.timeRanges = timeRanges
    this.id = id
    this.permission = permission
    this.targetId = targetId
    this.targetType = targetType
    this.userId = userId
  }

  onlyOpenTimeRanges() {
    return this.timeRanges.every((tr) => tr.isOpen())
  }
  listTimeRanges({ locale = 'en' }) {
    return this.timeRanges
      ?.sort((a, b) => {
        const aT = a.begin || a.end
        const bT = b.begin || b.end
        if (!aT) return 1
        if (!bT) return -1
        if (aT.isSameOrBefore(bT)) return -1

        return 1
      })
      ?.map((tr) => tr.toLocaleStrings({ locale }))
  }
}

export class TimeRange {
  constructor({ begin = null, end = null, beginInclusive, endInclusive }) {
    this.begin = !begin ? null : moment(begin)
    this.end = !end ? null : moment(end)
    this.beginInclusive = beginInclusive
    this.endInclusive = endInclusive
  }

  isOpen() {
    return this.begin === null && this.end === null
  }
  toLocaleStrings({ locale = 'en' }) {
    return {
      begin: this.begin === null ? null : formatTimestampToLocal(this.begin, { locale }),
      end: this.end === null ? null : formatTimestampToLocal(this.end, { locale })
    }
  }
  toResourceObject() {
    return {
      begin: this.begin === null ? null : this.begin.toISOString(),
      end: this.end === null ? null : this.end.toISOString()
    }
  }
}
